import { ofType, type Epic } from 'redux-observable';
import { from, of } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';

import Safescarf from '../../../api/safescarf';
import { handleError } from '../../errorHandler';

import { FETCH_ROLES_STARTED, fetchRolesFulfilled } from './actions';

const fetchRolesEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_ROLES_STARTED),
    mergeMap(() =>
      from(Safescarf.fetchSafescarfRoles()).pipe(
        mergeMap((response: { data: unknown }) => of(fetchRolesFulfilled(response.data))),
        catchError(handleError)
      )
    )
  );

export default fetchRolesEpic;
